(() => {
    const element = document.getElementById('profileLocationMap');
    if (!element) return;

    const position = {
        lat: Number(element.dataset.lat),
        lng: Number(element.dataset.lng),
    };
    if (!Number.isFinite(position.lat) || !Number.isFinite(position.lng)) return;

    function renderMap() {
        const map = new google.maps.Map(element, {
            center: position,
            zoom: 14,
            mapId: element.dataset.mapId || undefined,
            disableDefaultUI: true,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER,
            },
            gestureHandling: 'none',
            keyboardShortcuts: false,
            clickableIcons: false,
        });

        new google.maps.marker.AdvancedMarkerElement({
            map,
            position,
            title: element.dataset.name || 'Escort location',
        });
    }

    function loadMap() {
        if (window.google?.maps?.marker) {
            renderMap();
            return;
        }

        const callback = `initProfileLocationMap_${Date.now()}`;
        window[callback] = () => {
            delete window[callback];
            renderMap();
        };

        const params = new URLSearchParams({
            key: element.dataset.mapKey || '',
            callback,
            libraries: 'places,marker',
            loading: 'async',
            v: 'weekly',
        });
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }

    // The map sits near the bottom of the profile; only pull in the Maps API
    // when the visitor scrolls close to it so it doesn't weigh on page load.
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            loadMap();
        }, { rootMargin: '400px 0px' });
        observer.observe(element);
    } else {
        loadMap();
    }
})();